export default __webpack_public_path__ + "static/media/941.7f0fed16.jpg";